import PointManager from "../PointManager/PointManager";
import AngleManager from "../AngleManager/AngleManager";
import LineManager from "../LineManager";
import { eventBus, EnumEventBus } from "../EventBus";
import { runAnimation } from "./SupplementaryAnimationSequence";


export default class SupplementaryAnimation {
  private animated = false;
  constructor(
    private PointManager: PointManager,
    private AngleManager: AngleManager,
    private LineManager: LineManager,
  ) {
    eventBus.on(EnumEventBus.supplementaryMode, (v: boolean) => this.runAnimation(v));
  }
  runAnimation(isActive: boolean) {
    const context = {
      PointManager: this.PointManager,
      LineManager: this.LineManager,
      AngleManager: this.AngleManager
    }
    runAnimation(context, isActive)
  }

}